var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wrapWithProvider = void 0;

var react_1 = __importDefault(require("react"));

var admin_core_provider_1 = require("./admin-core-provider");

exports.wrapWithProvider = function (props) {
  return react_1.default.createElement(admin_core_provider_1.AdminCoreProvider, null, props.element);
};